import '../styles/Services.css';

const services = [
  {
    icon: '📸',
    color: 'teal',
    title: 'Instagram Yönetimi',
    desc: 'Profesyonel içerik takvimi, reels stratejisi ve hedefli reklam kampanyalarıyla markanızı öne çıkarın.',
    tags: ['Reels', 'Stories', 'Feed'],
  },
  {
    icon: '🎵',
    color: 'gold',
    title: 'TikTok Reklamları',
    desc: 'Viral içerik formatları ve algoritmaya uygun stratejilerle binlerce yeni takipçiye ulaşın.',
    tags: ['Viral', 'TopView', 'Spark Ads'],
  },
  {
    icon: '🎯',
    color: 'purple',
    title: 'Meta Reklam Yönetimi',
    desc: 'Facebook & Instagram\'da dönüşüm odaklı kampanyalar, A/B testler ve günlük optimizasyon.',
    tags: ['Retargeting', 'Lookalike', 'A/B Test'],
  },
  {
    icon: '💼',
    color: 'blue',
    title: 'LinkedIn Stratejisi',
    desc: 'B2B markanız için otorite içerikleri ve karar vericilere ulaşan hedefli reklam planları.',
    tags: ['B2B', 'Lead Gen', 'Otorite'],
  },
  {
    icon: '✍️',
    color: 'pink',
    title: 'İçerik Üretimi',
    desc: 'Grafik tasarım, video prodüksiyon ve copywriting hizmetleriyle dikkat çeken içerikler.',
    tags: ['Tasarım', 'Video', 'Copy'],
  },
  {
    icon: '📊',
    color: 'gold',
    title: 'Analitik & Raporlama',
    desc: 'Aylık detaylı performans raporları ve aksiyona dönüştürülebilir içgörülerle büyümenizi takip edin.',
    tags: ['KPI', 'Dashboard', 'ROI'],
  },
];

export default function Services() {
  return (
    <section className="services" id="hizmetler">
      <div className="services__head">
        <span className="label">Hizmetlerimiz</span>
        <h2 className="section-title">Her Platformda<br />Güçlü Bir Varlık</h2>
        <p className="services__sub">
          Hangi platformda olursa olsun, markanızın sesini doğru kitleye ulaştırıyoruz.
        </p>
      </div>

      <div className="services__grid">
        {services.map((s, i) => (
          <div key={i} className={`service-card service-card--${s.color}`}>
            <div className="service-card__icon">{s.icon}</div>
            <h3 className="service-card__title">{s.title}</h3>
            <p className="service-card__desc">{s.desc}</p>
            <div className="service-card__tags">
              {s.tags.map(t => (
                <span key={t} className="service-card__tag">{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
